// ============================================================================
// BANK DATA MANAGER - CONFIGURATION
// ============================================================================
// All configurable settings in one place for easy adjustment
// ============================================================================

// ============================================================================
// API ENDPOINTS
// ============================================================================

export const API_CONFIG = {
    // Cloudflare Worker URL for banking API
    WORKER_URL: "https://banking.jcmpagel.workers.dev",

    // OAuth callback URL
    REDIRECT_URL: "https://bank.jonathanpagel.com/success.html",
};

// ============================================================================
// EXCEL SHEET NAMES
// ============================================================================

export const SHEET_NAMES = {
    CONFIG: "BankConfig",
    TRANSACTIONS: "Transactions",
    MAPPING: "Mapping",
};

// ============================================================================
// POLLING & RETRY SETTINGS
// ============================================================================

export const TIMING_CONFIG = {
    // How often to check requisition status (ms)
    POLLING_INTERVAL: 3000,

    // Max retries for failed API calls
    MAX_RETRIES: 3,

    // Delay between retries (ms)
    RETRY_DELAY: 5000,

    // How long to cache bank status (ms)
    STATUS_CACHE_TTL: 20 * 60 * 1000, // 5 minutes
};




// ============================================================================
// TRANSACTION COLUMNS
// ============================================================================

export const CORE_COLUMNS = [
    "Booking Date",
    "Amount",
    "Currency",
    "Description",
    "Creditor/Debtor",
    "Type",
    "Category",
    "Sub Category",
    "IBAN",
    "Bank Name",
    "Account Name",
    "Transaction ID",
    "Unique Key",
];

// ============================================================================
// BANK STATUS MAPPING
// ============================================================================

export const STATUS_MAP: Record<string, { label: string; desc: string; color: string }> = {
    'CR': { label: 'Created', desc: 'Requisition created...', color: 'text-muted' },
    'GC': { label: 'Giving Consent', desc: 'Accept consent on the next screen...', color: 'text-warning' },
    'UA': { label: 'Authenticating', desc: 'Please finish login in your bank app...', color: 'text-warning' },
    'RJ': { label: 'Rejected', desc: 'Authorization was rejected.', color: 'text-danger' },
    'SA': { label: 'Selecting Accounts', desc: 'Please choose which accounts to link...', color: 'text-warning' },
    'GA': { label: 'Granting Access', desc: 'Finalizing bank permissions...', color: 'text-warning' },
    'LN': { label: 'Linked', desc: 'Successfully connected!', color: 'text-success' },
    'EX': { label: 'Expired', desc: 'Link has expired.', color: 'text-danger' },
};

// ============================================================================
// COMBINED CONFIG EXPORT (for backward compatibility)
// ============================================================================

export const CONFIG = {
    WORKER_URL: API_CONFIG.WORKER_URL,
    REDIRECT_URL: API_CONFIG.REDIRECT_URL,
    SHEETS: SHEET_NAMES,
    POLLING_INTERVAL: TIMING_CONFIG.POLLING_INTERVAL,
    MAX_RETRIES: TIMING_CONFIG.MAX_RETRIES,
    RETRY_DELAY: TIMING_CONFIG.RETRY_DELAY,
    STATUS_CACHE_TTL: TIMING_CONFIG.STATUS_CACHE_TTL,
};
